import {produce} from 'immer'

import React, {memo} from 'react'

import {useJobId} from '../../../../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {
  getDraftJobs,
  isSuggestionSkipped,
  getSkippedSuggestions,
} from '../../../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {
  pipelineDraft,
  suggestions,
} from '../../../../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../../../../hooks/pipeline'
import {StepTypes} from '../../../../../../../../../types'
import SuggestionMessage from '../../../../../../../SuggestionMessage/SuggestionMessage'
import type {SmartDetectorProps} from '../SmartDetectors.types'

import {parseMavenCommand} from './CliToMaven.utils'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

function CliToMaven({value, stepIndex, focused}: SmartDetectorProps) {
  const jobId = useJobId()!
  const id = usePipelineId()
  const stepId = `step-${jobId}-${stepIndex + 1}`
  const stepList = useAppSelector(state => getDraftJobs(state, id)?.[jobId]?.steps)
  const skippedSuggestionList = useAppSelector(state => getSkippedSuggestions(state, stepId))
  const isSkipped = useAppSelector(state => isSuggestionSkipped(state, stepId, StepTypes.MAVEN))

  const dispatch = useAppDispatch()

  const match = parseMavenCommand(value)
  const [_, goals] = match ?? []

  const visible = !isSkipped && !!match && focused

  return (
    <SuggestionMessage
      message={
        'We detected Maven. Want us to automatically collect and display test\u2011results for your Maven build by converting this to a Maven build step?'
      }
      actionText="Convert"
      visible={visible}
      onCancelClick={() => {
        dispatch(
          suggestions.actions.skip({
            id: stepId,
            values: produce(skippedSuggestionList ?? [], draft => {
              if (!draft.includes(StepTypes.MAVEN)) {
                draft.push(StepTypes.MAVEN)
              }
            }),
          }),
        )
      }}
      onActionClick={() => {
        dispatch(suggestions.actions.showSuccessMessage({id: stepId, type: StepTypes.MAVEN}))
        dispatch(
          pipelineDraft.actions.setSteps({
            id,
            jobId,
            steps: produce(stepList ?? [], draft => {
              const step = draft[stepIndex]
              step.type = StepTypes.MAVEN
              step.goals = goals
            }),
          }),
        )
      }}
    />
  )
}

export default memo<SmartDetectorProps>(CliToMaven)
